"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createIcon_1 = require("../../icons/util/createIcon");
var dateFormatter_1 = require("../formatting/dateFormatter");
var hoursMinutesSeconds_1 = require("../formatting/hoursMinutesSeconds");
var luxon_1 = require("luxon");
function renderCustomTooltip(data, metric, displayRange, language, timezone) {
    var markerConfig = data.w.config.markers;
    var values = data.series.map(function (element, index) {
        var name = data.w.config.series[index].name;
        var value = element[data.dataPointIndex];
        var shape = getConfigField(markerConfig.shape, index);
        var fill = getConfigField(markerConfig.colors, index);
        var stroke = getConfigField(markerConfig.strokeColors, index);
        var opacity = getConfigField(markerConfig.fillOpacity, index);
        var icon = createIcon_1.createIcon({
            shape: shape,
            fill: fill,
            stroke: stroke,
            opacity: opacity,
            asString: true,
            size: 10,
        });
        return { name: name, value: value, icon: icon };
    });
    var timestamp = data.w.config.series[0].data[data.dataPointIndex][0];
    var date = dateFormatter_1.formatDate(luxon_1.DateTime.fromISO(timestamp), displayRange, "TOOLTIP", language, timezone);
    var metrics = values
        .filter(function (value) { return value.value != undefined; })
        .sort(function (a, b) {
        return b.value - a.value;
    })
        .map(function (value) {
        var formattedValue = metric === "count" ? value.value : hoursMinutesSeconds_1.hoursMinutesSeconds(value.value, language);
        return "<div data-qa=\"tooltip-metric\" style=\"padding: 5px 0; display: flex; justify-content: space-between; min-width: 130px;\">\n                    <div style=\"margin-right: 20px;\">\n                        <svg width=\"10\" height=\"10\" style=\"margin-right: 5px;\">" + value.icon + "</svg><span data-qa=\"tooltip-metric-text\"> " + value.name + "</span>\n                    </div>\n                    <div data-qa=\"tooltip-metric-value\"><b>" + formattedValue + "</b></div> \n                </div>";
    })
        .reduce(function (acc, curr) { return acc + curr; });
    return "<div data-qa=\"tooltip-content\" style=\"padding: 20px; font-family: Noto Regular, Noto Sans; font-size: 12px;\">\n        <div style=\"margin-bottom: 10px;\" data-qa=\"tooltip-date\">\n            <b>" + date + "</b>\n        </div>\n        " + metrics + "\n    </div>";
}
exports.renderCustomTooltip = renderCustomTooltip;
/**
 * getConfigField - a lot of the config on charts can either be one value or an array of those values
 *                  e.g. shape can either be shape: "circle" or shape: ["circle", "square"]
 *
 * @param field field on config object you want
 * @param index index of the series
 */
function getConfigField(field, index) {
    return typeof field === "object" ? field[index] : field;
}
